import axios from "axios";
import { AppConstant } from "./AppConstant";

const HttpClient = axios.create({
  baseURL: AppConstant.ServerURL,
  headers: {
    "Content-Type": "application/json",
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  },
});

export default HttpClient;
